import { identify, makeRequest, Service } from '../../../utils/http';

export async function getAllDeliveriesApi() {
  return makeRequest(Service.getAllDeliveries(99999, 0, await identify()));
}
